const getSearchBottomTabHeaderStyles = () => ({
    zIndex: 10,
});

export default getSearchBottomTabHeaderStyles;
